import * as actionTypes from '../actionTypes';

const initialState = {
    areaNames: {}, // Store by areaId: { 123: [{ id, area_name, area }...] }
    isLoading: false,
    error: null
};

const areaReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Area Names
        case actionTypes.GetAreaNames:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case actionTypes.GetAreaNamesSuccess:
            return {
                ...state,
                isLoading: false,
                areaNames: {
                    ...state.areaNames,
                    [action.payload.areaId]: action.payload.data
                }
            };

        case actionTypes.GetAreaNamesFailure:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        // Add Area Name - optimistic update
        case actionTypes.AddAreaName:
            return {
                ...state,
                isLoading: true
            };

        case actionTypes.AddAreaNameSuccess:
            const { areaId: addAreaId, areaName } = action.payload;
            const existingAreas = state.areaNames[addAreaId] || [];
            return {
                ...state,
                isLoading: false,
                areaNames: {
                    ...state.areaNames,
                    [addAreaId]: [...existingAreas, areaName]
                }
            };

        case actionTypes.AddAreaNameFailure:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        // Update Area Name
        case actionTypes.UpdateAreaName:
            return {
                ...state,
                isLoading: true
            };

        case actionTypes.UpdateAreaNameSuccess:
            const { areaId: updateAreaId, areaNameId, updatedData } = action.payload;
            const areasToUpdate = state.areaNames[updateAreaId] || [];
            const updatedAreas = areasToUpdate.map(area =>
                area.id === areaNameId ? { ...area, ...updatedData } : area
            );
            return {
                ...state,
                isLoading: false,
                areaNames: {
                    ...state.areaNames,
                    [updateAreaId]: updatedAreas
                }
            };

        case actionTypes.UpdateAreaNameFailure:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default areaReducer;

